import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "../../../App.css";
import "../styles/Verified.css";

export default function Verified() {
  const [msg, setMsg] = useState("Verifying your email...");
  const [status, setStatus] = useState("loading"); // loading, success, error
  const [searchParams] = useSearchParams();
  const nav = useNavigate();

  useEffect(() => {
    const token = searchParams.get("token");
    if (!token) {
      setMsg("Invalid verification link.");
      setStatus("error");
      return;
    }

    fetch(`${process.env.REACT_APP_API_BASE_URL}/auth/verify-email?token=${token}`)
      .then(async (res) => {
        if (!res.ok) throw new Error(await res.text());
        setMsg("Your email has been successfully verified.\nYou can now sign in.");
        setStatus("success");
      })
      .catch(() => {
        setMsg("Verification link is invalid or expired.");
        setStatus("error");
      });
  }, [searchParams]);

  return (
    <div className="verified-page">
      <div className="verified-box">
        <h2 className="verified-title">🎉 Email Verification</h2>
        <p className={`verified-message ${status}`}>{msg}</p>
        {status === "success" && (
          <button 
            onClick={() => nav("/auth/react/signin")} 
            className="primary-btn verified-button"
          >
            Go to Sign In
          </button>
        )}
      </div>
    </div>
  );
}